import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import echarts from '../config'
import { cssVar } from '../../../../utils/cssVar'
import FadeIn from '../../../molecules/Transitions/FadeIn'

function applyChartConfig (data, options = {}) {
  const chartOptions = options?.chartOptions ?? {}

  return {
    textStyle: {
      fontFamily: chartOptions?.textStyle?.fontFamily ?? cssVar('--font-sans')
    },
    series: [
      {
        min: 0,
        max: 1.0,
        type: 'gauge',
        radius: chartOptions?.radius ?? '95%', // increase to reduce padding
        startAngle: 90,
        endAngle: -270,
        pointer: {
          show: false
        },
        progress: {
          show: true,
          overlap: false,
          roundCap: true,
          clip: false,
          itemStyle: {
            // color: '#4840bb',
            color: chartOptions?.progress?.itemStyle?.color ?? {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 1,
              y2: 0,
              colorStops: [
                { offset: 0, color: cssVar('--color-primary-500') },
                { offset: 1, color: cssVar('--color-accent-500') }
              ]
            },
            borderWidth: 0
            // borderColor: 'var(--color-growth-600)'
          }
        },

        // the progress line
        axisLine: {
          lineStyle: {
            width: 20,
            color: [[1, '#4840bb3c']]
          }
        },

        // hide split lines
        splitLine: {
          show: false,
          distance: 0,
          length: 10
        },

        // hide gauge ticks
        axisTick: {
          show: false
        },

        // hide gauge labels
        axisLabel: {
          show: false,
          distance: 50
        },

        detail: {
          width: 50,
          height: 14,
          color: chartOptions?.detail?.color ?? cssVar('--color-primary-700'),
          borderColor: 'inherit',
          borderRadius: 20,
          fontSize: chartOptions?.detail?.fontSize ?? 12,
          formatter: options?.valueFormat ?? '{value}%'
        },

        title: {
          color: chartOptions?.title?.color ?? cssVar('--text-color-main'),
          fontSize: chartOptions?.title?.fontSize ?? 12
        },

        data
      }
    ]
  }
}

function RingChart ({ height, width, valueFormat, data, chartOptions }) {
  const chartRef = useRef(null)
  const chartInstanceRef = useRef(null)

  useEffect(() => {
    if (chartRef.current && !chartInstanceRef.current) {
      chartInstanceRef.current = echarts.init(chartRef.current)
      window.addEventListener('resize', chartInstanceRef.current.resize)
    }

    return () => {
      if (chartInstanceRef.current) {
        window.removeEventListener('resize', chartInstanceRef.current.resize)
        chartInstanceRef.current.dispose()
        chartInstanceRef.current = null
      }
    }
  }, [])

  useEffect(() => {
    if (chartInstanceRef.current) {
      const chart = chartInstanceRef.current
      chart.setOption(applyChartConfig(data || [], {
        valueFormat,
        chartOptions
      }))
    }
  }, [data, valueFormat, chartOptions])

  return (
    <FadeIn>
      <div style={{ height, width }} ref={chartRef} />
    </FadeIn>
  )
}

RingChart.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  data: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    name: PropTypes.string
  })),
  valueFormat: PropTypes.func,
  chartOptions: PropTypes.object
}

export default RingChart
